import { IRequireLevel, systemModule } from '@/store/modules/ModuleSystem';

/**
 * 报表ID常量对照表
 *
 * @export
 * @class ReportConst
 */
export class ReportConst {
	// =================================== CAS ================================
	/**
	 * 评估申请查询-ams
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static APPLY_NEW_QUERY: string = 'APPLY_NEW_QUERY';

	/**
	 * 评估申请查询-csig
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static APPLY_NEW_QUERY_TWO: string = 'APPLY_NEW_QUERY_TWO';

	/**
	 * 评估我的申请查询-ams
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static MY_APPLY_NEW_QUERY: string = 'MY_APPLY_NEW_QUERY';

	/**
	 * 评估评估我的申请查询申请查询-csig
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static MY_APPLY_NEW_QUERY_TWO: string = 'MY_APPLY_NEW_QUERY_TWO';

	/**
	 * 评估指标查询
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static APPLY_INDEX_QUERY: string = 'APPLY_INDEX_QUERY';

	public static APPLY_INDEX_QUERY_TWO: string = 'APPLY_INDEX_QUERY_TWO';

	/**
	 * 评估结果查询
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static EVALUATION_NEW_QUERY: string = 'EVALUATION_NEW_QUERY';

	public static EVALUATION_NEW_QUERY_TWO: string = 'EVALUATION_NEW_QUERY_TWO';

	/**
	 * 我的评估结果查询
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static MY_EVALUATION_NEW_QUERY: string = 'MY_EVALUATION_NEW_QUERY ';

	public static MY_EVALUATION_NEW_QUERY_TWO: string = 'MY_EVALUATION_NEW_QUERY_TWO';

	/**
	 * 客户报告查询
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static YBR_ORDER_QUERY: string = 'YBR_ORDER_QUERY ';

	// =================================== BFC ================================

	/**
	 * 需求查询总金额-查询
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static CDP_QCP_REQUIRE_LIST_SUMMARY: string = 'REQUIRE_LIST_SUMMARY';

	/**
	 * 需求查询导出-查询
	 *
	 * @static
	 * @type {string}
	 * @memberOf ReportConst
	 */
	public static CDP_QCP_REQUIRE_EXPORT: string = 'REQUIRE_EXPORT';
}

/**
 * busEvent事件
 */
export class ReportEvent {
	public static TABLE_CHECK_LIST: string = 'table_check_list';

	// 弹框弹出
	public static SHOW_DIALOG: string = 'table_dialog';
}

/**
 * 报表ID数据结构
 *
 * @export
 * @interface IReportData
 */
export interface IReportData {
	reportId?: string;
	reportCode?: string;
	reportName?: string;
	desc?: string;
}

/** DS默认选中内容 */
export interface IDefaultField {
	name: string;
}

/** 系统报表数据 */
let reportList: Map<string, IReportData> = new Map();

/**
 * 获取系统报表数据数据
 *
 * @export
 * @returns {Array<IRequireLevel>}
 */
export function getReportRequireLevelListData(): Map<string, IReportData> {
	if (reportList.size === 0) {
		reportList = systemModule.reportList;
	}

	return reportList;
}

/**
 * 转换后端返回的列表内容成KEY-MAP
 *
 * @export
 * @param {*} reportData
 */
export function transferReportData(reportListSource: any): Map<string, IReportData> {
	// test
	// 驱动数据
	const reportData: any = {
		status: 0,
		data: [
			{
				reportId: 'RPT202111001266',
				reportCode: 'CDP_QCP_DECISION_DRAFT_LIST',
				reportName: '内容设计_QQ内容采购_决策_草稿_查询',
				desc: '内容设计_QQ内容采购_决策_草稿_查询'
			}
		],
		message: null
	};
	// test
	const reportDataMap: Map<string, IReportData> = new Map();
	if (reportData && reportData.data && reportData.data.length) {
		for (let index = 0; index < reportData.data.length; index++) {
			const element = reportData.data[index];
			reportDataMap.set(element.reportCode, element);
		}
	}

	return reportDataMap;
}

/**
 * 依据KEY常量查找报表ID
 *
 * @export
 * @param {string} key
 * @returns {string}
 */
export function getReportIdByKey(key: string = ReportConst.APPLY_NEW_QUERY): string {
	// console.log('key', key);
	// const listData: Map<string, IReportData> = getReportRequireLevelListData();
	// let element: IReportData = {};
	// for (const [keyLabel, value] of listData.entries()) {
	// 	if (keyLabel.indexOf(key) !== -1) {
	// 		element = value;
	// 		// console.log('key getReportIdByKey', key);
	// 		break;
	// 	}
	// }

	// if (element) {
	// 	return element.reportCode || key;
	// }

	return key;
}

/**
 * 依据KEY常量查找报表ID
 *
 * @export
 * @param {string} key
 * @returns {string}
 */
export function getSourceReportId(key: string = ReportConst.APPLY_NEW_QUERY): string {
	// console.log('key', key);
	// const element = getReportRequireLevelListData().get(key);

	// if (element) {
	// 	return element.reportId || key;
	// }

	return key;
}

/** 依据ID换取CODE */
export function getReportCodeById(id: any): string {
	// console.log('getReportCodeById...', id);
	const list: Map<string, IReportData> = getReportRequireLevelListData();

	let findedKey: string = '';
	// eslint-disable-next-line guard-for-in
	for (const item of list) {
		const [key, value]: any = item;
		if (value.reportId === id) {
			findedKey = key;
			break;
		}
	}

	return findedKey;
}

/** 按钮权限 */
export const statusShow: string = '1';
export const statusDisable: string = '0';
export const statusNo: string = '-1';
// /** 显示 */
// public static statusShow:
// /** 置灰 */
// public static statusDisable: string = '0';
// /** 不显示 */
// public static statusNo: string = '-1';
